<template>
  <AppCard @click="emits('tileClick')" to="#" :is-selected="isSelected" :is-actionable="true" :is-disabled="isDisabled">
    <div class="t-flex category-card">
      <div
        class="category-card--icon t-flex t-flex-align-items-center t-flexShrink0 t-mr-4"
        v-if="hasSlot('icon')"
      >
        <slot name="icon" />
      </div>
      <div class="category-card--details">
        <div
          v-if="hasSlot('title')"
          class="category-card--title t-mb-1"
          :class="[
            {
              'is-title-small': isTitleSizeSmall
            }
          ]"
        >
          <slot name="title" />
        </div>
        <p class="category-card--desc" v-if="hasSlot('desc')">
          <slot name="desc" />
        </p>
      </div>
    </div>
  </AppCard>
</template>
<script setup lang="ts">
import AppCard from "@/components/global/TCard/TCard.vue"
import { useSlots } from "vue"

const props = defineProps({
  isTitleSizeSmall: {
    type: Boolean,
    default: false
  },
  isSelected: {
    type: Boolean,
    default: false
  },
  iconSize: {
    type: String,
    default: ""
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
})

const slots = useSlots()
const emits = defineEmits(["tileClick"])

const hasSlot = (name: string) => {
  return !!slots[name]
}
</script>
<style scoped lang="scss">
@import "@/styles/mixins/typography";

.category-card {
  &--title {
    @include tg-heading-5;

    &.is-title-small {
      @include tg-heading-6;
    }
  }

  &--details {
    align-content: center;
  }

  &--desc {
    @include tg-small;
    color: var(--telekom-color-text-and-icon-additional);
  }
}
</style>
